import { Component, Input } from '@angular/core';
import { IconComponent } from '@tribeauto/ngx-mobilite-material';
import { NgClass } from '@angular/common';

@Component({
  selector: 'fol-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
  imports: [IconComponent, NgClass]
})
export class StepComponent {
  @Input() num: number | string = '';
  @Input() title = '';
  @Input() validated = false;
  @Input() active = false;
}
